<template>
  <v-dialog v-model="dialogo" width="600" persistent>
    <v-card>
      <v-card-title>
        Historico Produto
        <v-spacer></v-spacer>
        <v-btn @click="fechar()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="produto">
        <v-simple-table>
          <tbody>
            <tr>
              <th class="text-right" width="150">
                Produto
              </th>
              <td>
                {{ produto.produto_nome }}
              </td>
            </tr>
            <tr>
              <th class="text-right" width="150">
                Preço
              </th>
              <td>
                {{ produto.preco_unitario }} x {{ produto.quantidade }} =
                {{ produto.total }}
              </td>
            </tr>
            <tr>
              <th class="text-right" width="150">
                Datas
              </th>
              <td>
                {{ formatDate(produto.data_inicial) }} -
                {{ formatDate(produto.data_final) }}
              </td>
            </tr>
            <tr
              :class="{
                'green--text':
                  produto.quantidade_entregue >= produto.quantidade,
                'orange--text': produto.quantidade_entregue < produto.quantidade
              }"
            >
              <th class="text-right" width="150">
                Entregue
              </th>
              <td>
                {{ produto.quantidade_entregue }} / {{ produto.quantidade }}
              </td>
            </tr>
            <tr
              :class="{
                'green--text':
                  produto.quantidade_recolhida >= produto.quantidade,
                'orange--text':
                  produto.quantidade_recolhida < produto.quantidade
              }"
            >
              <th class="text-right" width="150">
                Recolhido
              </th>
              <td>
                {{ produto.quantidade_recolhida }} / {{ produto.quantidade }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-list>
          <v-subheader>
            MOVIMENTAÇÃO
          </v-subheader>
          <template v-for="item in timeline">
            <v-list-item :key="item.id">
              <v-list-item-icon>
                <v-icon v-if="item.tipo === 'E'" color="red">
                  mdi-arrow-up-bold
                </v-icon>
                <v-icon v-else-if="item.tipo === 'R'" color="green">
                  mdi-arrow-down-bold
                </v-icon>
                <v-icon v-else-if="item.tipo === 'L'" color="orange">
                  mdi-keyboard-return
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span v-if="!item.data" class="caption"
                    >(Data indefinida)</span
                  >
                  <span v-else>{{ formatDate(item.data) }}</span
                  >:
                  {{ item.quantidade + " " + tipoParaTexto(item.tipo) }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="item.data">
                  {{ item.total_dias }} dias
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="`divider-${item.id}`"></v-divider>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import locacoes from "@/services/locacoes";
import dateTimeMixin from "@/mixins/DateTimeMixin";

export default {
  mixins: [dateTimeMixin],

  components: {},

  props: {},

  data() {
    return {
      dialogo: false,
      produto: null,
      timeline: []
    };
  },

  methods: {
    abrir(produto) {
      this.produto = { ...produto };
      this.dialogo = true;

      this.carregarHistorico(produto.id);
    },
    tipoParaTexto(tipo) {
      switch (tipo) {
        case "R":
          return "recolhido(s)";
        case "E":
          return "entregue(s)";
        case "L":
          return "relocado(s)";
      }
    },
    fechar() {
      this.dialogo = false;
    },

    async carregarHistorico(produto_id) {
      const response = await locacoes.locacoes_produtos.historico(produto_id);

      this.timeline = response.data.data;
    }
  },

  computed: {}
};
</script>
